import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import Pagination from "./../../../component/molecules/pagination";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
import RedBtn from "../../../component/atoms/button/redBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import PretendardText from "../../../component/atoms/text/pretendardText";
import scrollToTop from "./../../../util/scrollToTop";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import BlueBtn from "./../../../component/atoms/button/blueBtn";
import { route } from "./../../../router/route";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import CancelSalePopup from "../../../component/templates/salesManage/cancelSalePopup";
import CancelApprovePopup from "../../../component/templates/salesManage/cancelApprovePopup";
import CancelRejectPopup from "../../../component/templates/salesManage/cancelRejectPopup";
import { errorHandler } from "../../../util/errorHandler";
import OrderApi from "../../../api/order.api";
import { fileUrl } from "../../../api/api";
import Empty from "../../../component/molecules/empty";
import AlarmSendPopup from "../../../component/templates/user/userInfo/alarmSendPopup";
import SMSSendPopup from "../../../component/templates/user/userInfo/smsSendPopup";

const ShoppingSell = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.shopping_sell)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [activationList, setActivationList] = useState([
    {
      title: "결제 완료",
      value: "PAY_COMPLETE",
    },
    {
      title: "취소 요청",
      value: "CANCEL_REQUEST",
    },
    {
      title: "취소 거절",
      value: "CANCEL_REJECT",
    },
    {
      title: "취소 완료",
      value: "CANCEL_COMPLETE",
    },
  ]);

  const [keyword, setKeyword] = useState("");
  const [activationFilter, setActivationFilter] = useState("");
  const [alarmPopupOpen, setAlarmPopupOpen] = useState(false);
  const [smsPopupOpen, setSMSPopupOpen] = useState(false);

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setActivationFilter(
      searchParams.get("activation") ? searchParams.get("activation") : ""
    );

    getSellList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [sellList, setSellList] = useState([]);

  const getSellList = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
        isMembership: "Inactive",
        // paymentFlag: "Active",
      };

      if (keyword) {
        data.keyword = searchParams.get("keyword");
      }

      if (searchParams.get("activation")) {
        data.orderStatus = searchParams.get("activation");
      }

      const response = (await OrderApi.getListOrder(data)).data.data;

      const processedResponse = response.content.map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
          checked: false,
          imageIsValid: true,
        };
      });

      const processedDataWithImages = await Promise.all(
        processedResponse.map(
          (item) =>
            new Promise((resolve) => {
              if (item.thumbnailServerFileName) {
                const img = new Image();
                img.src = `${fileUrl}/${item.thumbnailServerFileName}`;

                img.onload = () => {
                  resolve({ ...item, imageIsValid: true });
                };

                img.onerror = () => {
                  resolve({ ...item, imageIsValid: false });
                };
              } else {
                resolve(item);
              }
            })
        )
      );

      setSellList(processedDataWithImages);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [clickedValue, setClickedValue] = useState();

  useEffect(() => {
    const checkedList = sellList.filter((item) => item.checked);
    if (checkedList.length === 1) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [sellList]);

  // ---------- 결제 상태 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(false);

  // ---------- 팝업 관련 ---------- //
  const [cancelSalePopupOpen, setCancelSalePopupOpen] = useState(false);
  const [cancelApprovePopupOpen, setCancelApprovePopupOpen] = useState(false);
  const [cancelRejectPopupOpen, setCancelRejectPopupOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>판매관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"구매"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"구매번호, 구매자, 상품명, 결제수단 등"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.shopping_sell}?page=1&keyword=${keyword}`
                    );
                  }
                }}
                onClick={() => {
                  navigate(`${route.shopping_sell}?page=1&keyword=${keyword}`);
                }}
              />
              {/* <ExcelBtn /> */}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              {clickedValue?.orderStatus === "PAY_COMPLETE" && (
                <>
                  <RedBtn
                    style={{
                      backgroundColor: "#272829",
                    }}
                    onClick={() => {
                      setCancelSalePopupOpen(true);
                    }}
                  >
                    판매취소
                  </RedBtn>
                  <GrayBtn
                    onClick={() => {
                      setAlarmPopupOpen(true);
                    }}
                  >
                    알림 보내기
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      setSMSPopupOpen(true);
                    }}
                  >
                    SMS 보내기
                  </GrayBtn>
                </>
              )}
              {clickedValue?.orderStatus === "CANCEL_REQUEST" && (
                <>
                  <BlueBtn
                    style={{
                      backgroundColor: "#272829",
                    }}
                    onClick={() => {
                      setCancelApprovePopupOpen(true);
                    }}
                  >
                    취소 승인
                  </BlueBtn>
                  <RedBtn
                    style={{
                      backgroundColor: "#272829",
                    }}
                    onClick={() => {
                      setCancelRejectPopupOpen(true);
                    }}
                  >
                    취소 거절
                  </RedBtn>
                  <GrayBtn
                    onClick={() => {
                      setAlarmPopupOpen(true);
                    }}
                  >
                    알림 보내기
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      setSMSPopupOpen(true);
                    }}
                  >
                    SMS 보내기
                  </GrayBtn>
                </>
              )}
              {(clickedValue?.orderStatus === "CANCEL_COMPLETE" ||
                clickedValue?.orderStatus === "CANCEL_REJECT") && (
                <>
                  <GrayBtn
                    onClick={() => {
                      setAlarmPopupOpen(true);
                    }}
                  >
                    알림 보내기
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      setSMSPopupOpen(true);
                    }}
                  >
                    SMS 보내기
                  </GrayBtn>
                </>
              )}
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* No */}
              <col width="47px" />
              {/* 구매번호/시각 */}
              <col width="187px" />
              {/* 구매 상품 */}
              <col width="265px" />
              {/* 상품 금액 */}
              <col width="97px" />
              {/* 결제 내역 */}
              <col width="174px" />
              {/* 상태 */}
              <col width="123px" />
              {/* 보기 */}
              <col width="95px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}></Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    구매번호/시각
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    구매 상품
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    상품 금액
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      paddingLeft: "30px",
                    }}
                  >
                    결제 내역
                  </TableText>
                </Th>
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                    <img
                      className={filterOpen === true ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFilterOpen(!filterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {filterOpen && (
                      <FilterWrapper>
                        {activationList.map((item, index) => {
                          return (
                            <FilterTextWrapper key={index}>
                              <FilterText
                                onClick={() => {
                                  if (activationFilter === item.value) {
                                    navigate(
                                      `${route.shopping_sell}?page=1&keyword=${keyword}&activation=`
                                    );
                                  } else {
                                    navigate(
                                      `${route.shopping_sell}?page=1&keyword=${keyword}&activation=${item.value}`
                                    );
                                  }
                                }}
                              >
                                {item.title}
                                {activationFilter === item.value ? (
                                  <img
                                    src="/assets/admin/icons/ico_selectbox_checked.svg"
                                    alt="선택됨"
                                  />
                                ) : null}
                              </FilterText>
                            </FilterTextWrapper>
                          );
                        })}
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {sellList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "107px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          if (item.checked) {
                            setSellList(
                              sellList.map((sellItem) => {
                                return {
                                  ...sellItem,
                                  checked: false,
                                };
                              })
                            );

                            setClickedValue();
                          } else {
                            setSellList(
                              sellList.map((sellItem) => {
                                return {
                                  ...sellItem,
                                  checked: sellItem.id === item.id,
                                };
                              })
                            );

                            setClickedValue(item);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    {/* 구매번호/시각 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: "130px",
                          }}
                        >
                          {item.payNumber}
                        </TableText>
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          {moment(item.createdAt).format("YYYY-MM-DD HH:mm")}
                        </PretendardText>
                      </div>
                    </Td>
                    {/* 구매 상품 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 16,
                        }}
                      >
                        {item.thumbnailServerFileName && item.imageIsValid ? (
                          <img
                            src={`${fileUrl}/${item.thumbnailServerFileName}`}
                            alt="상품 이미지"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              backgroundColor: "#272829",
                            }}
                          />
                        )}
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                            maxWidth: "191px",
                          }}
                        >
                          {item.orderTitle}
                        </PretendardText>
                      </div>
                    </Td>
                    {/* 상품 금액 */}
                    <Td>
                      <TableText>
                        {formatNumberWithCommas(item.totalPay)}원
                      </TableText>
                    </Td>
                    {/* 결제 내역 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: "112px",
                          }}
                        >
                          실결제 {formatNumberWithCommas(item.realPay)}원
                        </TableText>
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          결제 방법: {item.payMethod}
                        </PretendardText>
                        {item.couponPay > 0 || item.pointPay > 0 ? (
                          <PretendardText
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              lineHeight: "18.75px",
                              color: "rgba(181, 181, 181, 0.5)",
                            }}
                          >
                            포인트 사용/쿠폰 사용
                          </PretendardText>
                        ) : null}
                      </div>
                    </Td>
                    {/* 상태 */}
                    <Td>
                      <TableText
                        style={{
                          textAlign: "center",
                          color: `${
                            item.orderStatus === "PAY_COMPLETE"
                              ? "#009bde"
                              : item.orderStatus === "CANCEL_REQUEST"
                              ? "#cf6679"
                              : "#aaa"
                          }`,
                        }}
                      >
                        {item.orderStatus === "PAY_COMPLETE"
                          ? "결제 완료"
                          : item.orderStatus === "CANCEL_REQUEST"
                          ? "취소 요청"
                          : item.orderStatus === "CANCEL_REJECT"
                          ? "취소 거절"
                          : item.orderStatus === "CANCEL_COMPLETE"
                          ? "취소 완료"
                          : ""}
                      </TableText>
                    </Td>
                    {/* 보기 */}
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(
                            `${route.shopping_sell_detail}/${item.orderStatus}/${item.id}`
                          );
                          scrollToTop();
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {sellList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.shopping_sell}
            queryString={`keyword=${keyword}&activation=${activationFilter}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {cancelSalePopupOpen && (
        <CancelSalePopup
          setPopupOpen={setCancelSalePopupOpen}
          sellData={clickedValue}
          getSellList={getSellList}
        />
      )}

      {cancelApprovePopupOpen && (
        <CancelApprovePopup
          setPopupOpen={setCancelApprovePopupOpen}
          sellData={clickedValue}
          getSellList={getSellList}
        />
      )}

      {cancelRejectPopupOpen && (
        <CancelRejectPopup
          setPopupOpen={setCancelRejectPopupOpen}
          sellData={clickedValue}
          getSellList={getSellList}
        />
      )}

      {/* 알림 보내기 */}
      {alarmPopupOpen && (
        <AlarmSendPopup
          setPopupOpen={setAlarmPopupOpen}
          userCheckedIdList={[
            {
              id: clickedValue.buyerId,
              email: clickedValue.buyerEmail,
            },
          ]}
          getMemberList={() => {}}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={setButtonGroupOpen}
        />
      )}

      {/* SMS 보내기 */}
      {smsPopupOpen && (
        <SMSSendPopup
          setPopupOpen={setSMSPopupOpen}
          userCheckedIdList={[
            {
              phoneNumber: clickedValue.buyerPhoneNumber,
            },
          ]}
          getMemberList={() => {}}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={setButtonGroupOpen}
        />
      )}
    </>
  );
};

export default ShoppingSell;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;
